// 阿拉伯数字转中文数字（支持 0 ~ 亿亿）
const CHN_NUM_CHAR = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
const CHN_UNIT_SECTION = ['', '万', '亿', '万亿', '亿亿'];
const CHN_UNIT_CHAR = ['', '十', '百', '千'];

function sectionToChinese(section: number): string {
  let strIns = '';
  let chnStr = '';
  let unitPos = 0;
  let zero = true;
  while (section > 0) {
    const v = section % 10;
    if (v === 0) {
      if (!zero) { zero = true; chnStr = CHN_NUM_CHAR[v] + chnStr; }
    } else {
      zero = false;
      strIns = CHN_NUM_CHAR[v];
      strIns += CHN_UNIT_CHAR[unitPos];
      chnStr = strIns + chnStr;
    }
    unitPos++;
    section = Math.floor(section / 10);
  }
  return chnStr;
}

export function numberToChinese(num: number): string {
  if (num === 0) return CHN_NUM_CHAR[0];
  let unitPos = 0;
  let strIns = '';
  let chnStr = '';
  let needZero = false;
  while (num > 0) {
    const section = num % 10000;
    if (needZero) chnStr = CHN_NUM_CHAR[0] + chnStr;
    strIns = sectionToChinese(section);
    strIns += (section !== 0) ? CHN_UNIT_SECTION[unitPos] : CHN_UNIT_SECTION[0];
    chnStr = strIns + chnStr;
    needZero = (section < 1000) && (section > 0);
    num = Math.floor(num / 10000);
    unitPos++;
  }
  if (chnStr.startsWith('一十')) chnStr = chnStr.substring(1);
  return chnStr;
}
